import {
  Button,
  Card,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Select,
  Space,
  Table,
  Typography,
  Upload,
} from "antd"
import { addDoc, collection, onSnapshot, query, serverTimestamp, where } from "firebase/firestore"
import React, { useEffect, useState } from "react"
import { db, storage } from "../../../firebase/config"
import { CheckCircleFilled, InboxOutlined, LoadingOutlined, PlusCircleOutlined, CopyOutlined } from "@ant-design/icons"
import { useCollection } from "../../../hooks/useCollection"
// import axios from "axios"

import { ref as storageRef, uploadBytesResumable } from "firebase/storage"
import useSerachKnifeWithButton from "../../../hooks/useSerachKnifeWithButton"

const { Link, Title, Text } = Typography
const { TextArea } = Input

export default function NewVivaPlateModal(props) {
  const { data: clientList, loading: clientListLoading } = useCollection("clients")

  //props for check if its coming from order details
  const { comingFromOrderDetails, dataDetails, selectedKnife, onPlateCreated } = props

  //gettings knives
  const { knifeData, knifeLoading, fetchDataWithSearch } = useSerachKnifeWithButton()

  //init form
  const [form] = Form.useForm()


  //create button loading
  const [buttonLoading, setButtonLoading] = useState(false)

  //loading
  const [loading, setLoading] = useState(false)

  const [knifeWidth, setKnifeWidth] = useState(0)
  const [knifeHeight, setKnifeHeight] = useState(0)
  const [knifeRange, setKnifeRange] = useState(0)

  //product list
  const [productList, setProductList] = useState([])
  const [productListLoading, setProductListLoading] = useState(false)

  //main data object
  const [dataObject, setDataObject] = useState({
    clientId: null,
    client: null,
    code: null,
    codeNumber: null,
    codePrefix: null,
    important: "none",
    knifeNumber: null,
    knifeCode: null,
    knifeRows: null,
    layoutDesign: null,
    product: null,
    productId: null,
    width: null,
    height: null,
    rows: null,
    designerProductName: null,
    isMultiple: false,
    plateLocation: null,
    machine: "viva",
    plateRef: "vivaPlateList",
    storageRef: "vivaPlates",
    paid: false,
    plateStatus: "new",
  })

  const [openDrawer, setOpenDrawer] = useState(false)

  const [fileList, setFileList] = useState([])
  const [folderName, setFolderName] = useState("")
  const [uploadProgress, setUploadProgress] = useState({})

  const plateFolder = "vivaPlates"

  const beforeUpload = (file) => {
    setFileList([...fileList, file])
    // Prevent automatic upload
    return false
  }

  const showDrawer = () => {
    setOpenDrawer(true)
  }
  const onClose = () => {
    setOpenDrawer(false)
  }

  const onFinish = (values) => {
    console.log("Success:", values)
    createNewPlate()
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  //SECTION : COMING FROM ORDER DETAILS
  useEffect(() => {
    if (openDrawer && comingFromOrderDetails) {
      setDataObject({
        clientId: dataDetails.clientId,
        client: dataDetails.client.client,
        product: dataDetails.selectedProduct.product.productName,
        productId: dataDetails.selectedProduct.id,
        plateLocation: "Kengarags",
        rows: selectedKnife.rowss,
      })
      console.log("last", selectedKnife)

      // Set the initial value of the "client" field
      form.setFieldsValue({
        client: dataDetails.client.client,
        product: dataDetails.selectedProduct.product.productName,
        plateLocation: "Kengarags",
        rows: selectedKnife.rowss,
      })

      //handles knife
      handleKnifeSelect(selectedKnife)
      setKnifeWidth(selectedKnife.width)
      setKnifeHeight(selectedKnife.height)
    }
  }, [dataDetails, openDrawer, form, comingFromOrderDetails, selectedKnife])

  useEffect(() => {
    setProductListLoading(true)
    const colRef = collection(db, "priceCalculation")
    let q = query(colRef, where("clientId", "==", dataObject.clientId))

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const data = doc.data()
        results.push({ ...data, key: doc.id, id: doc.id })
      })
      setProductList(results)
      setProductListLoading(false)
    })

    return () => unsubscribe()
  }, [dataObject.clientId])

  const handleUpload = (files, folder, plateFolder) =>
    new Promise((resolve, reject) => {
      if (!files.length) { resolve(); return }
      let completed = 0
      let failed = 0
      files.forEach((file) => {
        const fileRef = storageRef(storage, `${plateFolder}/${folder}/${file.name}`)
        const task = uploadBytesResumable(fileRef, file)
        task.on(
          "state_changed",
          (snap) => {
            const pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100)
            setUploadProgress((prev) => ({ ...prev, [file.name]: pct }))
          },
          (err) => {
            message.error(`${file.name} failed: ${err.message}`)
            failed++
            completed++
            if (completed === files.length) failed ? reject(new Error("Some uploads failed")) : resolve()
          },
          () => {
            setUploadProgress((prev) => ({ ...prev, [file.name]: 100 }))
            completed++
            if (completed === files.length) resolve()
          }
        )
      })
    })

  //new plate creation
  const createNewPlate = async () => {
    try {
      setButtonLoading(true)
      setLoading(true) // Set loading state to true when the function starts executing

      // First, upload all files
      await handleUpload(fileList, folderName, plateFolder)

      console.log(dataObject)

      // Once all uploads are complete, add the document
      const collectionRef = collection(db, "vivaPlateList")
      const docRef = await addDoc(collectionRef, {
        ...dataObject,
        created: serverTimestamp(),
        updated: serverTimestamp(),
      })
      message.success("New plate added!")

      // Auto-select the new plate if a callback was provided (e.g. from order details)
      if (onPlateCreated) {
        onPlateCreated({ ...dataObject, id: docRef.id })
      }
      setFileList([]) // Clear the file list once upload and document creation are done
    } catch (error) {
      console.error("Error:", error)
      message.error(error.message)
    } finally {
      setFileList([])
      setUploadProgress({})
      setOpenDrawer(false)
      form.resetFields()
      setButtonLoading(false)
      setLoading(false)
    }
  }

  //handle select for client
  const handleClientSelect = (value, option) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      client: option.client,
      clientId: option.id,
    }))
    form.resetFields(["product"])
  }

  //handle select for product
  const handleProductSelect = (value, option) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      product: value,
      productId: option.id,
    }))
  }

  //handle copy product name
  const handleCopyProduct = () => {
    if (dataObject.product) {
      navigator.clipboard.writeText(dataObject.product)
      message.success("Product name copied!")
    } else {
      message.warning("No product selected to copy")
    }
  }

  //handle change for code input
  const handleCodeChange = (value) => {
    const totalCode = "VIVA" + value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      code: "VIVA" + value,
      codeNumber: value,
      codePrefix: "VIVA",
    }))
    console.log(totalCode)
    setFolderName(totalCode)
  }

  //get last knife plate code
  const buttonForLast = () => <Link onClick={getLastCode}>Get last</Link>
  const getLastCode = () => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      codeNumber: props.lastPlate.codeNumber + 1,
      code: "VIVA" + (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"),
      codePrefix: "VIVA",
    }))
    console.log("VIVA" + (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"))
    setFolderName("VIVA" + (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"))
    form.setFieldValue("code", (props.lastPlate.codeNumber + 1).toString().padStart(4, "0"))
  }

  //handle knife Select
  const handleKnifeSelect = (value) => {
    //strip the code into a number
    const knifeCode = value.code
    const pureNumber = knifeCode.replace(/\D/g, "")
    const numericValuePureNumber = parseInt(pureNumber)
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      knifeCode: value.code,
      knifeRows: value.rowss,
      knifeNumber: numericValuePureNumber,
      width: value.width,
      height: value.height,
    }))
  }

  //handles plate rows
  const handlePlateRows = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      rows: value,
    }))
  }

  //handles layout name
  const handleLayoutName = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      layoutDesign: value,
    }))
  }

  //handle comment
  const handleComment = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      important: value,
    }))
  }

  //handle designer name
  const handleDesignerName = (event) => {
    const value = event.target.value
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      designerProductName: value,
    }))
  }

  //handles plate location
  const handlePlateLocation = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      plateLocation: value,
    }))
  }
  //handlePlateStatus
  const handlePlateStatus = (value) => {
    setDataObject((prevDataObject) => ({
      ...prevDataObject,
      plateStatus: value,
    }))
  }

  //knife search
  const handleKnifeSearch = () => {
    // Call fetchDataWithSearch with the necessary parameters
    fetchDataWithSearch(null, knifeWidth, knifeHeight, knifeRange, "any", 0, "Viva")
  }

  //knife choosing
  const returnKnifeSelect = () => {
    //knife columns table
    const knifeCols = [
      {
        title: "Code",
        dataIndex: "code",
        align: "center",
      },
      {
        title: "Width",
        dataIndex: "width",
        align: "center",
      },
      {
        title: "Height",
        dataIndex: "height",
        align: "center",
      },
      {
        title: "Rows",
        dataIndex: "rowss",
        align: "center",
      },
      {
        title: "Form Type",
        dataIndex: "TypeOfForm",
        align: "center",
      },
      {
        title: "Action",
        dataIndex: "id",
        align: "center",
        render: (value, record) => {
          return (
            <>
              <Button onClick={() => handleKnifeSelect(record)}>Select this</Button>
            </>
          )
        },
      },
    ]

    return (
      <div>
        <Card
          title={"Selected Knife : " + dataObject.knifeCode}
          extra={
            <Space>
              <InputNumber
                style={{ width: 100 }}
                value={knifeWidth}
                onChange={setKnifeWidth}
                min={0}
                placeholder="width"
                prefix={`W: `}
                size="small"
              />
              <InputNumber
                style={{ width: 100 }}
                value={knifeHeight}
                onChange={setKnifeHeight}
                min={0}
                placeholder="height"
                size="small"
                prefix={`H: `}
              />
              <InputNumber
                style={{ width: 100 }}
                value={knifeRange}
                onChange={setKnifeRange}
                min={0}
                placeholder="range"
                prefix={`Range: `}
                size="small"
              />
              <Button onClick={() => handleKnifeSearch()} type="primary" size="small">
                Search
              </Button>
            </Space>
          }
          size="small"
          style={{
            width: "100%",
          }}>
          <Table
            size="small"
            bordered
            pagination={{ defaultPageSize: "5", showSizeChanger: true }}
            rowKey={(record) => record.id}
            loading={knifeLoading}
            columns={knifeCols}
            dataSource={knifeData && knifeData}
          />
        </Card>
      </div>
    )
  }


  return (
    <>
      <Button icon={<PlusCircleOutlined />} onClick={showDrawer}></Button>
      <Drawer
        width={700}
        title="New viva plate"
        placement="right"
        onClose={onClose}
        open={openDrawer}>
        <Form
          form={form}
          name="clientForm"
          initialValues={{
            remember: true,
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ width: "100%" }}>
          <Form.Item
            label="Select client"
            name="client"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              showSearch
              placeholder="Select client"
              optionFilterProp="children"
              onChange={handleClientSelect}
              fieldNames={{ label: "client", value: "id", key: "id" }}
              loading={clientListLoading}
              filterOption={(input, option) =>
                (option?.client ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={clientList && clientList}
            />
          </Form.Item>
          <Form.Item
            label="Select product"
            name="product"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Space.Compact style={{ width: "100%" }}>
              <Select
                showSearch
                placeholder="Select product"
                onChange={handleProductSelect}
                loading={productListLoading}
                filterOption={(input, option) => {
                  return option.children.toLowerCase().includes(input.toLowerCase())
                }}
                style={{ flex: 1 }}>
                {productList &&
                  productList.map((option, index) => (
                    <Select.Option key={index} id={option.id} value={option?.product?.productName}>
                      {option?.product?.productName}
                    </Select.Option>
                  ))}
              </Select>
              {dataObject.product && (
                <Button
                  type="text"
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={handleCopyProduct}
                  title="Copy product name"
                  style={{ color: "#1677ff" }}
                />
              )}
            </Space.Compact>
          </Form.Item>
          <Form.Item label="Designer product name (optional)" name="designerProductName">
            <Input
              placeholder="Write your own product slogan"
              style={{ width: "100%" }}
              onChange={handleDesignerName}
            />
          </Form.Item>
          <Form.Item
            label="Plate Code"
            name="code"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <InputNumber
              style={{ width: "100%" }}
              addonAfter={buttonForLast()}
              prefix="VIVA"
              min={0}
              onChange={handleCodeChange}
            />
          </Form.Item>
          <Form.Item label="Select Knife" name="knife">
            {returnKnifeSelect()}
          </Form.Item>
          <Form.Item
            label="Plate rows"
            name="rows"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <InputNumber style={{ width: "100%" }} min={0} max={100} onChange={handlePlateRows} />
          </Form.Item>
          <Form.Item
            label="Layout Name"
            name="layoutName"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Input style={{ width: "100%" }} onChange={handleLayoutName} />
          </Form.Item>
          <Form.Item
            label="Plate Location"
            name="plateLocation"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              onChange={handlePlateLocation}
              options={[
                {
                  value: "Not Ordered",
                  label: "Not Ordered",
                },
                {
                  value: "Ordered",
                  label: "Ordered (in proccess)",
                },
                {
                  value: "Kengarags",
                  label: "At Kengarags",
                },
                {
                  value: "Visvaldis",
                  label: "At Visvaldis",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="Platus Status"
            name="plateStatus"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Select
              onChange={handlePlateStatus}
              options={[
                {
                  value: "used",
                  label: "used",
                },
                {
                  value: "new",
                  label: "new",
                },
              ]}
            />
          </Form.Item>
          <Form.Item label="Plate files" name="filesList">
            {!buttonLoading && <div style={{ height: 100, marginBottom: 4 }}>
              <Upload.Dragger
                beforeUpload={(file) => { setFileList((prev) => [...prev, file]); return false }}
                fileList={fileList}
                onRemove={(file) => setFileList(fileList.filter((f) => f.uid !== file.uid))}
                multiple
                style={{ height: "100%" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                  <InboxOutlined style={{ fontSize: 22, color: "#1677ff" }} />
                  <div>
                    <p style={{ margin: 0, fontWeight: 500, fontSize: 13 }}>Click or drag files to upload</p>
                    <p style={{ margin: 0, fontSize: 11, color: "#999" }}>PDF, images or other plate files</p>
                  </div>
                </div>
              </Upload.Dragger>
            </div>}
            {Object.entries(uploadProgress).map(([name, pct]) => (
              <div
                key={name}
                style={{
                  padding: "8px 12px",
                  marginTop: 6,
                  background: pct === 100 ? "#f6ffed" : "#e6f4ff",
                  border: `1px solid ${pct === 100 ? "#b7eb8f" : "#bae0ff"}`,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}>
                {pct === 100
                  ? <CheckCircleFilled style={{ color: "#52c41a" }} />
                  : <LoadingOutlined style={{ color: "#1677ff" }} />}
                <span style={{ fontSize: 12, flex: 1 }}>{name}</span>
                <span style={{ fontSize: 12, fontWeight: 600, color: pct === 100 ? "#52c41a" : "#1677ff" }}>
                  {pct}%
                </span>
              </div>
            ))}
          </Form.Item>
          <Form.Item
            label="Important"
            name="important"
            rules={[
              {
                message: "Please input your field!",
              },
            ]}>
            <TextArea rows={4} style={{ width: "100%" }} onChange={handleComment} />
          </Form.Item>
          <Form.Item>
            <Button
              disabled={dataObject.knifeNumber === null ? true : false}
              loading={buttonLoading}
              block
              type="primary"
              htmlType="submit">
              Create plate
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}
